import React from "react";
import { Outlet } from "react-router-dom";

// COMPONENTS Import
import Navbar from "../../components/LandingPage/Navbar";

const LandingPageContainer = () => {
  return (
    <>
      <div
        className="App"
        style={{ backgroundColor: "var(--Blue-1)" }}
      >
        <Navbar />
        <Outlet />
      </div>
    </>
  );
};

export default LandingPageContainer;
